import { z } from "zod";
import { uuidSchema } from "./domain";

const localDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((value) => {
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
  }, "Data non valida.");
export const statisticsAdsAccountInputSchema = z
  .object({
    connectionId: uuidSchema,
    accountId: z
      .string()
      .regex(/^(?:act_)?\d{1,32}$/)
      .transform((value) => value.replace(/^act_/, "")),
    campaignIds: z
      .array(z.string().regex(/^\d{1,32}$/))
      .min(1)
      .max(100)
      .transform((ids) => [...new Set(ids)].sort()),
    nativeLeadAction: z
      .string()
      .regex(/^[a-z][a-z0-9_.]{0,127}$/)
      .default("onsite_conversion.lead_grouped"),
    backfillFrom: localDate.optional(),
  })
  .strict();
export type StatisticsAdsAccountInput = z.infer<typeof statisticsAdsAccountInputSchema>;

export const statisticsSourcesDtoSchema = z
  .object({
    adsAccounts: z.array(
      z
        .object({
          id: uuidSchema,
          connectionId: uuidSchema,
          accountId: z.string(),
          name: z.string().nullable(),
          currency: z.string().nullable(),
          timezone: z.string().nullable(),
          campaignIds: z.array(z.string()),
          nativeLeadAction: z.string(),
          backfillFrom: z.string().nullable(),
          lastSyncedAt: z.string().nullable(),
          lastError: z.string().nullable(),
        })
        .strict(),
    ),
    connections: z.array(
      z
        .object({
          id: uuidSchema,
          label: z.string(),
          kind: z.enum(["meta_whatsapp", "meta_lead_ads", "meta_messaging"]),
        })
        .strict(),
    ),
    economicsConfigured: z.boolean(),
  })
  .strict();
export type StatisticsSourcesDto = z.infer<typeof statisticsSourcesDtoSchema>;

export const statisticsSyncJobSchema = z
  .object({
    workspaceId: uuidSchema,
    correlationId: uuidSchema,
    idempotencyKey: z.string().min(8).max(256),
    trigger: z.enum(["manual", "scheduled", "configured", "backfill"]),
  })
  .strict();
export type StatisticsSyncJob = z.infer<typeof statisticsSyncJobSchema>;
